module.exports = __webpack_public_path__ + "static/media/ic_black_close.625c80e6.svg";